import ky from "ky-universal";

const getSelectAudienceTypeData = async (url, audienceTypeId, countryKey) => {
	let apiUrl;
	if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
		apiUrl = "http://localhost:7000/audience-selector-api/select-audience-type";
	} else {
		apiUrl = url;
	}
	const newData = await ky
		.post(apiUrl, {
			headers: new Headers({
				"Content-Type": "application/json"
			}),
			body: JSON.stringify({
				audienceTypeId,
				countryKey
			})
		})
		.then((response) => {
			if (response.status === 200) {
				return response.json().then((data) => {
					if (Object.hasOwn(data, "status")) {
						if (data.status === "failed") {
							console.error(data);
							// { "status": "failed", "action": "none" }
							return {
								status: data.status,
								data: data
							};
						}
						if (data.action === "reload") {
							// { status: "success", action: "reload" }
							return {
								status: data.status,
								data: data.action
							};
						}
						if (data.action === "display-affirmation-screen") {
							return {
								status: "success",
								data: { ...data, countryKey }
							};
						}
						return {
							status: "success",
							data: data
						};
					}
					return {
						status: "success",
						data: data
					};
				});
			} else {
				return {
					status: "failed",
					error: `${response.status}`
				};
			}
		})
		.then((res) => res)
		.catch((error) => {
			console.error(error);
			return {
				status: "failed",
				error: error
			};
		});
	return newData;
};

export default getSelectAudienceTypeData;
